// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduled-campaign-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 20px;
    margin: 20px auto; 
    gap: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px; 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .scheduled-campaign-report-field {
        display: flex;
        flex-direction: column;
        width: 25%
    }
      
    .scheduled-campaign-report-field label {
        font-weight: bold;
        margin-bottom: 8px;
        text-align: left;
    }
      
    .scheduled-campaign-report-field input {
        padding: 10px 5px;
        font-size: 16px;
        border: 1px solid #f2f2f2;
    }  


    .scheduled-campaign-form-actions {
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 15px 0 0;
      }
      
      .scheduled-campaign-form-actions .btn {
        padding: 8px 16px;
        font-size: 16px;
        color: #fff;
        background-color: #44a67e;
        border-color: #44a67e;
        border-radius: 4px;
        cursor: pointer;
      }
      
      /* .scheduled-campaign-form-actions .btn:hover {
        background-color: #0056b3;
      } */

/* Scheduled Campaign Table Style */
.schedule-campaign-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.schedule-campaign-table th,
.schedule-campaign-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.schedule-campaign-table th {
  background-color: #f4f4f4;
  color: #373435;
  font-weight: 600;
  text-transform: uppercase;
  text-align: left;
}

.schedule-campaign-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.schedule-campaign-table tbody tr:hover {
  background-color:  rgba(255, 204, 41, 0.2);
}

.schedule-campaign-table td {
  color: #555;
}

.schedule-campaign-table tbody tr:last-child td {
  border-bottom: 2px solid #ffcc29;
}

/* Expand Button */
.schedule-campaign-expand-btn {
  background: #373435;
  color: #ffcc29;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
}

.schedule-campaign-expand-btn:hover {
  background: #ffcc29;
  color: #373435;
}

/* Expanded Row */
.schedule-campaign-expanded-row {
  background-color: #eef7ff;
}

.schedule-campaign-expanded-content {
  padding: 10px;
}

.delete-short-url {
  background-color: #fb3d4e;
  color: #fff;
  border: 1px solid #fb3d4e;
  padding: 8px 10px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 5px;
}

.delete-short-url:hover {
  background-color: #c82333;
}

.delete-short-url:disabled {
  opacity: 0.8;  
  cursor: not-allowed; 
  filter: blur(1px);
}

.delete-short-url:disabled:hover {
  background-color: #fb3d4e;
}


.wrap-schedule-campaign {
  margin: 0 40px;
}

`, "",{"version":3,"sources":["webpack://./src/components/ScheduledCampaign/ScheduledCampaign.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,yBAAyB;IAC7B;;;IAGA;QACI,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,iBAAiB;MACnB;;MAEA;QACE,iBAAiB;QACjB,eAAe;QACf,WAAW;QACX,yBAAyB;QACzB,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;MACjB;;MAEA;;SAEG;;AAET,mCAAmC;AACnC;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,cAAc;AAChB","sourcesContent":[".scheduled-campaign-form {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 25px 20px;\r\n    margin: 20px auto; \r\n    gap: 20px;\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px; \r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    }\r\n\r\n    .scheduled-campaign-report-field {\r\n        display: flex;\r\n        flex-direction: column;\r\n        width: 25%\r\n    }\r\n      \r\n    .scheduled-campaign-report-field label {\r\n        font-weight: bold;\r\n        margin-bottom: 8px;\r\n        text-align: left;\r\n    }\r\n      \r\n    .scheduled-campaign-report-field input {\r\n        padding: 10px 5px;\r\n        font-size: 16px;\r\n        border: 1px solid #f2f2f2;\r\n    }  \r\n\r\n\r\n    .scheduled-campaign-form-actions {\r\n        display: flex;\r\n        gap: 10px;\r\n        align-items: center;\r\n        padding: 15px 0 0;\r\n      }\r\n      \r\n      .scheduled-campaign-form-actions .btn {\r\n        padding: 8px 16px;\r\n        font-size: 16px;\r\n        color: #fff;\r\n        background-color: #44a67e;\r\n        border-color: #44a67e;\r\n        border-radius: 4px;\r\n        cursor: pointer;\r\n      }\r\n      \r\n      /* .scheduled-campaign-form-actions .btn:hover {\r\n        background-color: #0056b3;\r\n      } */\r\n\r\n/* Scheduled Campaign Table Style */\r\n.schedule-campaign-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  text-align: left;\r\n}\r\n\r\n.schedule-campaign-table th,\r\n.schedule-campaign-table td {\r\n  padding: 12px 15px;\r\n  border: 1px solid #ddd;\r\n  font-size: 14px;\r\n}\r\n\r\n.schedule-campaign-table th {\r\n  background-color: #f4f4f4;\r\n  color: #373435;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n}\r\n\r\n.schedule-campaign-table tbody tr:nth-child(even) {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.schedule-campaign-table tbody tr:hover {\r\n  background-color:  rgba(255, 204, 41, 0.2);\r\n}\r\n\r\n.schedule-campaign-table td {\r\n  color: #555;\r\n}\r\n\r\n.schedule-campaign-table tbody tr:last-child td {\r\n  border-bottom: 2px solid #ffcc29;\r\n}\r\n\r\n/* Expand Button */\r\n.schedule-campaign-expand-btn {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n}\r\n\r\n.schedule-campaign-expand-btn:hover {\r\n  background: #ffcc29;\r\n  color: #373435;\r\n}\r\n\r\n/* Expanded Row */\r\n.schedule-campaign-expanded-row {\r\n  background-color: #eef7ff;\r\n}\r\n\r\n.schedule-campaign-expanded-content {\r\n  padding: 10px;\r\n}\r\n\r\n.delete-short-url {\r\n  background-color: #fb3d4e;\r\n  color: #fff;\r\n  border: 1px solid #fb3d4e;\r\n  padding: 8px 10px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-left: 5px;\r\n}\r\n\r\n.delete-short-url:hover {\r\n  background-color: #c82333;\r\n}\r\n\r\n.delete-short-url:disabled {\r\n  opacity: 0.8;  \r\n  cursor: not-allowed; \r\n  filter: blur(1px);\r\n}\r\n\r\n.delete-short-url:disabled:hover {\r\n  background-color: #fb3d4e;\r\n}\r\n\r\n\r\n.wrap-schedule-campaign {\r\n  margin: 0 40px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
